import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import SectionWrapper from "../../../section-wrapper";
import { updateCompanySettings } from "../../../store/gat-admin-slice";
import { GATAdminCompany, LocationType } from "../../../store/gat-admin-slice-types";
import SectionActions from "../../section-actions/index";
import AdvancedSchedulingLocation from "./advanced-scheduling";
import { transformSettingsToState, transformStateToSettingsPayload } from "./settings-mappers";

export interface LocationAddOnSettings {
    isEnabled: boolean;
    allowWorkerPreferences: boolean;
    autoOptimize: boolean;
}
interface AddOnSettingsLocationProps {
    locationData: LocationType;
    companyDataValue: GATAdminCompany;
}

const AddOnSettingsLocation: React.FC<AddOnSettingsLocationProps> = ({ locationData, companyDataValue }) => {
    const dispatch = useDispatch();
    const locationId = locationData?.id;

    const companySettings = useSelector((state: any) => state.gatAdminConfiguration.companySettings);
    const locationSettings = useSelector((state: any) => state.gatAdminConfiguration.locationSettings);
    const updateStatus = useSelector((state: any) => state.gatAdminConfiguration.updateCompanySettings.status);
    const getLocationSettingsStatus = useSelector((state: any) => state.gatAdminConfiguration.getLocationSettings.status);

    const [originalSettings, setOriginalSettings] = useState<LocationAddOnSettings | null>(null);
    const [currentSettings, setCurrentSettings] = useState<LocationAddOnSettings | null>(null);

    useEffect(() => {
        if (locationSettings && Object.keys(locationSettings).length > 0) {
            const transformedState = transformSettingsToState(locationSettings);
            setOriginalSettings(transformedState);
            setCurrentSettings(transformedState);
        }
    }, [locationSettings]);

    const handleSave = () => {
        if (!currentSettings || !locationId) return;
        const payload = transformStateToSettingsPayload(currentSettings, locationId);
        dispatch(updateCompanySettings(payload));
    };

    const handleDiscard = () => {
        if (originalSettings) {
            setCurrentSettings(originalSettings);
        }
    };

    const isCompanyAdvancedSchedulingEnabled = companySettings["fullTimeScheduling.enabled"]?.value ?? false;

    if (!currentSettings) {
        return null;
    }

    return (
        <SectionWrapper
            title="Add Ons Settings"
            subtitle=""
            // subtitle="Configure additional features and services for this location"
        >
            <AdvancedSchedulingLocation
                currentSettings={currentSettings}
                setCurrentSettings={setCurrentSettings}
                isCompanyAdvancedSchedulingEnabled={isCompanyAdvancedSchedulingEnabled}
                locationId={locationId}
            />

            <SectionActions
                oldData={originalSettings}
                newData={currentSettings}
                resetChanges={handleDiscard}
                handleSave={handleSave}
                status={updateStatus === "pending" || getLocationSettingsStatus === "pending" ? "pending" : "fulfilled"}
                loading={updateStatus === "pending"}
                companyDataValue={companyDataValue}
            />
        </SectionWrapper>
    );
};

export default AddOnSettingsLocation;